<template>
    <div style="padding: 20px; box-shadow: 3px 3px 10px #aaa; " class="panel">
        <div class="panel-title" style="background-color: #7af;">
            <h2 style="padding: 10px; margin:0; color: #fff;">
                Currently Working On
            </h2>
        </div>
        <div class="panel-body" style="height: 567px;">
            <div v-if="loading" align="center" style="padding-top: 200px">
                <i class="fa fa-spinner fa-spin fa-4x"></i>
            </div>
            <div v-show="!loading">
                <span v-if="runningTasks.length === 0"> - none - </span>
                <div v-show="runningTasks.length > 0" style="height: 539px; overflow-y: scroll">
                    <table class="table display compact table-hover" id="running-tasks-table">
                        <thead>
                        <tr>
                            <th style="text-align: left">Lesson</th>
                            <th style="text-align: left">Task</th>
                            <th style="text-align: left">Started</th>
                            <th style="text-align: left">Unassign</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="task in runningTasks"
                            :key="task.taskId"
                            :data-href="task.lessonBlocked ? '#' : task.taskRoute"
                            v-tooltip="task.lessonBlocked ? 'This lesson is currently under investigation and cannot be worked on, please check again later.' : ''"
                        >
                            <td :class="task.lessonBlocked ? 'disabled-cell' : 'clickable-cell'" style="text-align: left">
                                <b>{{task.lessonCode}}</b><br/>
                                {{task.lessonTitle}}
                            </td>
                            <td :class="task.lessonBlocked ? 'disabled-cell' : 'clickable-cell'" style="text-align: left">
                                {{task.actionTitle}}<br/>
                                <small>{{task.language + ', ' + task.country}}</small>
                            </td>
                            <td :data-sort="task.startedAt ? convertToDateTime(task.startedAt) : ''"
                                :class="task.lessonBlocked ? 'disabled-cell' : 'clickable-cell'" style="text-align: left">
                        <span :class="task.lessonBlocked ? 'disabled-cell' : 'clickable-cell'" style="white-space: nowrap"
                              :title="task.startedAt ? convertToDateTime(task.startedAt) : 'unknown'">
                            {{convertToHumanReadable(task.startedAt)}}
                        </span>
                            </td>
                            <td>
                                <button @click="unassign(task, $event.target);"
                                        class="btn btn-sm btn-default" style="text-align: left">
                                    <i class="fa fa-remove" style="color: darkred"></i> Unassign
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="panel-title" style="background-color: #9c2924; margin-top: 30px;">
            <h2 style="padding: 10px; margin:0; color: #fff">
                Summary
            </h2>
        </div>
        <div class="panel-body" style="min-height: 328px;">
            <div v-if="loading" align="center" style="padding-top: 200px">
                <i class="fa fa-spinner fa-spin fa-4x"></i>
            </div>
            <div v-show="!loading">
                <span v-if="Object.keys(currentTasksAndProjectedEarnings).length === 0"> - none - </span>
                <div v-show="Object.keys(currentTasksAndProjectedEarnings).length > 0" style="min-height: 300px">
                    <div class="row">
                        <div class="col-xs-12">
                            <table class="table display compact table-hover" id="current-tasks-table">
                                <thead>
                                    <tr>
                                        <th scope="col">Task</th>
                                        <th scope="col">Count</th>
                                        <th scope="col">Cost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="key in Object.keys(currentTasksAndProjectedEarnings)" :key="key">
                                        <td>{{key}}</td>
                                        <td>{{currentTasksAndProjectedEarnings[key].length}}</td>
                                        <td>{{`${currentTasksAndProjectedEarnings[key].length * parseFloat(currentTasksAndProjectedEarnings[key][0].taskCost)} ${currentTasksAndProjectedEarnings[key][0].currency}`}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><strong>TOTAL ASSIGNED</strong></td>
                                        <td></td>
                                        <td><strong>{{projectedEarningsString}}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </div>
</template>

<style>
    .clickable-cell {
        cursor: pointer;
    }
    .disabled-cell {
        cursor: not-allowed;
        color: #E7EAEC;
    }
    .tooltip {
        display: block !important;
        z-index: 10000;
    }

    .tooltip .tooltip-inner {
        background: black;
        color: white;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: black;
        z-index: 1;
    }

    .tooltip[x-placement^="top"] {
        margin-bottom: 5px;
    }

    .tooltip[x-placement^="top"] .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="bottom"] {
        margin-top: 5px;
    }

    .tooltip[x-placement^="bottom"] .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip.popover .popover-inner {
        background: #f9f9f9;
        color: black;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, .1);
    }

    .tooltip.popover .popover-arrow {
        border-color: #f9f9f9;
    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }
</style>


<script>
    import {groupBy} from '../../helpers/groupBy';

    let moment = require('moment');
    require('../../../vendor/jquery/plugins/dataTables/datatables.min');

    export default {
        props: [
            'csrfToken',
            'userId',
            'updateAssignableTasks',
        ],

        data() {
            return {
                loading: true,
                runningTasks: [],
                currentTasksAndProjectedEarnings: [],
                projectedEarningsString: [],
                tableRendered: false,
                currentTasksTableRendered: false,
            };
        },

        mounted: function() {
            this.fetchRunningTasks();
            this.fetchCurrentTasksAndProjectedEarnings();
        },

        computed: {},

        updated: function() {
            this.$nextTick(function() {
                this.renderDataTable();
            });
        },

        methods: {
            convertToDateTime: (atomString) => moment(atomString).local().format('YYYY-MM-DD HH:mm:ss'),
            convertToHumanReadable: (atomString) => moment(atomString).local().fromNow(),
            renderDataTable: function() {
                const tableNode = $('#running-tasks-table');
                if (this.tableRendered) {
                    tableNode.DataTable().destroy();
                }
                tableNode.DataTable({
                    paging: false,
                    responsive: true,
                    dom: 'ft',
                    bInfo: false,
                    stateSave: true,
                    stateDuration: 0,
                });

                $('.clickable-cell').click(function() {
                    window.location = $(this).parent().data('href');
                });


                const tasksTableNode = $('#current-tasks-table');
                if (this.currentTasksTableRendered) {
                    tasksTableNode.DataTable().destroy();
                }
                tasksTableNode.DataTable({
                  ordering: false,
                  searching: false,
                  paging: false,
                  responsive: true,
                  dom: 'ft',
                  bInfo: false,
                  stateSave: true,
                  stateDuration: 0,
                });

                this.tableRendered = true;
                this.currentTasksTableRendered = true;
            },

            fetchRunningTasks: function() {
                fetch('/user/' + this.userId + '/runningTasks')
                .then(response => response.json())
                .then(data => {
                    if (this.tableRendered) {
                        $('#running-tasks-table').DataTable().destroy();
                    }
                    this.runningTasks = data;
                })
                .catch((error) => {
                    console.error('Error:', error);
                    alert('An error occurred trying to fetch your running tasks. '
                        + 'Please take a screenshot and report the error!\n\n' + error);
                });
            },

            fetchCurrentTasksAndProjectedEarnings: function() {
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({userId: this.userId})
                };
                fetch('/api/coordination/user/currentTasksAndProjectedEarnings', requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        if (this.currentTasksTableRendered) {
                            $('#current-tasks-table').DataTable().destroy();
                        }
                        if (data.tasks.length > 0) {
                          let total = data.tasks.map(task => task.taskCost).reduce((sum, a) => sum + a, 0)
                          this.projectedEarningsString = `${total} ${data.tasks[0].currency}`
                          this.currentTasksAndProjectedEarnings = groupBy(data.tasks, 'description')
                        } else {
                          this.currentTasksAndProjectedEarnings = []
                        }
                    })
                    .then(() => {
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        alert('An error occurred trying to fetch current task summary. '
                            + 'Please take a screenshot and report the error!\n\n' + error);
                    });
            },

            unassign: function(task, buttonDomElement) {
                buttonDomElement.disabled = true;
                const iconNode = buttonDomElement.children[0];
                iconNode.classList.remove('fa-remove');
                iconNode.classList.add('fa-spinner');
                iconNode.classList.add('fa-spin');
                fetch('/task/' + task.taskId + '/unassign', {
                    method: 'PUT',
                    headers: {
                        'X-CSRF-TOKEN': this.csrfToken,
                    },
                }).then(response => {
                    this.fetchRunningTasks();
                    this.fetchCurrentTasksAndProjectedEarnings();
                    this.updateAssignableTasks({
                      label: task.actionTitle,
                      code: task.actionId
                    });
                });
            },
        },
    };
</script>
